export default __webpack_public_path__ + "static/media/education-img-cover-carat.ea3f14ae.png";